<template>
    <v-flex>
        <div class="elevation-3">
    
            <div class="noTableHeader">
                <v-dialog persistent v-model="modal" max-width="500px">
                    <v-btn slot="activator" color="#f8ac4a" dark class="mb-2">
                        <v-icon class="buttonIconText" color="white">playlist_add</v-icon> Novo {{name}}</v-btn>
                    <v-card>
                        <v-card-title>
                            <span class="headline">{{ formTitle }}</span>
                        </v-card-title>
                        <v-form ref="form" v-on:submit.prevent>
                            <v-card-text>
                                <v-container grid-list-md>
                                    <div v-if="isLoading" style="width: 100%; text-align: center;">
                                            <v-progress-circular indeterminate color="amber"/>
                                        </div>
                                    <v-layout v-if="!isLoading" wrap>
                                        <v-flex xs12 sm12 md12>
                                            <label class="label-modal">Nome</label>
                                            <v-text-field color="#f8ac4a" :autofocus="true" :rules="defaultRules" v-model="editedItem.nome"></v-text-field>
                                        </v-flex>
                                        <v-flex xs12 sm12 md12>
                                            <label class="label-modal">Perguntas</label>
                                            <v-select color="#f8ac4a" :items="getPerguntas" multiple v-model="editedItem.perguntas" item-text="nome" item-value="id_pergunta" :rules="defaultRules"></v-select>
                                        </v-flex>
                                    </v-layout>
                                </v-container>
                            </v-card-text>
                            <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn color="#f8ac4a" flat @click.native="close">Cancelar</v-btn>
                                <v-btn color="#f8ac4a" :disabled="isLoading" flat @click.native="save">Guardar</v-btn>
                            </v-card-actions>
                        </v-form>
                    </v-card>
                </v-dialog>
    
                <v-text-field color="#f8ac4a" class="searchTable" v-model="search" append-icon="search" label="Pesquisa" single-line hide-details></v-text-field>
            </div>
    
            <v-dialog persistent v-model="deleteM" max-width="390">
                <v-card>
                    <v-card-title class="headline" style="margin-left: 0px !important;">Apagar {{name}}</v-card-title>
                    <v-card-text>De certeza que quer apagar este {{name}}?</v-card-text>
                    <v-card-actions style="margin-top: 0px !important;">
                        <v-spacer></v-spacer>
                        <v-btn color="#f8ac4a" flat="flat" @click.native="close">Cancelar</v-btn>
                        <v-btn color="#f8ac4a" flat="flat" @click.native="save">Apagar</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
    
            <v-data-table :headers="headers" :items="DATA" :search="search" :loading="loading" item-key="id" :disable-initial-sort="true" :rows-per-page-items='[10,25,50,{"text":"Todos","value":-1}]' rows-per-page-text="Itens por página:">
                <template slot="items" slot-scope="props">
                        <td @click="editItem(props.item, true)" style="width: 15%;" class="textLeft">{{ props.item.id_formulario }}</td>
                        <td @click="editItem(props.item, true)" style="width: 60%" class="textLeft">{{ props.item.nome }}</td>
                        <td class=" px-0 textTable textCenter">
                        	<v-btn icon class="mx-0" @click="editItem(props.item, true)">
                                <v-icon color="light-green darken-1">edit</v-icon>
                            </v-btn>
                            <v-btn icon class="mx-0" @click="editItem(props.item, false)">
                                <v-icon color="red lighten-1">delete</v-icon>
                            </v-btn>
                        </td>
</template>

<template class="alertTable" slot="no-data">
    <v-alert :value="true" icon="warning">
        De momento não há nada a apresentar! :(
    </v-alert>
</template>
            </v-data-table>
            
        </div>
    </v-flex>
</template>

<script>
import { instance as axios } from "../../store/axios";
import { mapState, mapGetters, mapActions } from "vuex";
    const cName = {
        upper: "Formulário",
        lower: "o formulário!"
    };
    
    export default {
        data: () => ({
            isLoading: false,
            table: 'formularios',
            name: 'formulário',
            search: "",
            modal: false,
            deleteM: false,
            loading: true,
            searchP: '',
            headers: [
            {
                text: "#",
                align: "left",
                sortable: true,
                value: "id_formulario"
            },
            {
                text: "Nome",
                align: "left",
                sortable: true,
                value: "nome"
            },
            {
                text: "Ações",
                value: "id",
                sortable: false,
                align: "center"
            }
            ],
            DATA: [],
            editedIndex: -1,
            editedItem: {
                id_formulario: 0,
                nome: "",
                perguntas: []
            },
            defaultItem: {
                id_formulario: 0,
                nome: "",
                perguntas: []
            },
            messages: {
                add: {
                    success: cName.upper + " criado com sucesso!",
                    error: "Ocorreu um erro ao criar " + cName.lower
                },
                update: {
                    success: cName.upper + " alterado com sucesso!",
                    error: "Ocorreu um erro ao alterar " + cName.lower
                },
                delete: {
                    success: cName.upper + " eliminado com sucesso!",
                    error: "Ocorreu um erro ao apagar " + cName.lower
                },
                default: {
                    sucesso: "Sucesso",
                    error: "Ocorreu um erro!"
                }
            },
            defaultRules: null
        }),
    
        computed: {
            ...mapGetters({
                getAll: 'formularios/getAll',
                getPerguntas: 'perguntas/getAll'
            }),
            formTitle() {
                return this.editedIndex === -1 ? "Novo "+this.name : "Editar "+this.name;
            }
        },
    
        watch: {
            modal(val) {
                val || this.close()
            },
            deleteM(val) {
                val || this.close()
            },
            getAll(val) {
                this.initialize()
            }
        },
    
        created() {
            this.defaultRules = [v => !!v || this.$requiredField + ''];
            this.initialize();
       },
        mounted() {
            
        },
        methods: {
            toast(type, message) {
                if (type == "success") {
                    return iziToast.show({
                        title: "SUCESSO",
                        color: "green",
                        timeout: this.$toastTimeout,
                        message: message,
                        position: this.$toastPosition
                    });
                } else {
                    return iziToast.show({
                        title: "AVISO",
                        color: "red",
                        timeout: this.$toastTimeout,
                        message: message,
                        position: this.$toastPosition
                    });
                }
            },

            initialize() {
                this.loading = true;
                this.DATA = this.getAll;
                this.loading = false;
            },
    
            editItem(item, dialog) {
                this.editedIndex = this.DATA.indexOf(item);

                if (dialog) {
                    this.isLoading = true;
                    this.modal = true;
                    axios.get("/formulario/"+item.id_formulario).then((res) => {
                        this.editedItem = {...res.data.data[0]};
                        this.isLoading = false;
                    });
                }
                else {
                    this.editedItem = {...item};
                    this.deleteM = true;
                }
            },

    
            delete() {
                if(!this.editedItem.id_formulario) return;

                this.$store
                    .dispatch(this.table+"/delete", {id: this.editedItem.id_formulario})
                    .then((res) => {
                        if(res) { this.toast('success', this.messages.delete.success); this.initialize(); }
                        else this.toast('error', this.messages.delete.error);
                            
                        this.deleteM = false;
                    });
            },
    
            close() {
                this.modal = this.deleteM = this.isLoading = false;
                setTimeout(() => {
                    this.editedItem = Object.assign({}, this.defaultItem);
                    this.editedIndex = -1;
                    
                    this.$refs.form.reset();
                }, 110);
            },
    
            async save() {
                
                if(this.deleteM) {this.delete(); return;}

                if(!this.$refs.form.validate()) return;

                if(this.editedItem.perguntas.length == 0) {this.toast('error', 'O formulário deve ter no minimo uma pergunta associada.'); return}

                if(this.editedIndex == -1) {
                    this.$store
                    .dispatch(this.table+"/insert", {formulario: this.editedItem})
                    .then((res) => {
                        if(res) { this.toast('success', this.messages.add.success); this.initialize(); }
                        else this.toast('error', this.messages.add.error);
                            
                        this.modal = false;
                    });
                }
                else {
                    this.editedItem.perguntas = await this.formatArray();
                    
                    this.$store
                    .dispatch(this.table+"/update", {formulario: this.editedItem})
                    .then((res) => {
                        if(res) { this.toast('success', this.messages.update.success); this.initialize(); }
                        else this.toast('error', this.messages.update.error);
                            
                        this.modal = false;
                    });
                }
            },

            formatArray() {
                return this.editedItem.perguntas.hasOwnProperty('id_pf') ? this.editedItem.perguntas.map((el)=>{ return el.id_pergunta }) : this.editedItem.perguntas;
            }
        }
    }
</script>




// WEBPACK FOOTER //
// src/components/tables/Table_Formularios.vue